import request from '@/utils/request'

export function getRaffleTimes(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/my/reward',
    method: 'post',
    params: data
  })
}

export function getDrawResult(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/draw',
    method: 'post',
    params: data
  })
}

export function putShare() {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/anniversary/celebration/share/wechat/friend',
    method: 'post',
  })
}



export function rankingList(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/order/ranking/list',
    method: 'get',
    params: data
  })
}




export function saveAddrInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/recipient/address',
    method: 'post',
    data
  })
}



export function fetchRecipientAddress(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/recipient/address',
    method: 'get',
    params: data
  })
}









// WEBPACK FOOTER //
// ./src/views/activity_138/api.js